import { Alert, Box, LinearProgress } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../../contexts/user-context/user-context';
import LogoUploader from './logo-uploader/logo-uploader';
import Section from './section';
import axios from 'axios';
import {
  OrganisationSettings,
} from '../../../interfaces/delivery-company/orders';
import { API_ENDPOINT } from '../../../configurations/global.config';
import ThemeColor from './color-theme/color-theme';
import Grid2 from '@mui/material/Unstable_Grid2';
import NotificationManagerTemplates from './notification-manager/notification-manager-templates';
import { emptyOrgSettings } from '../../../data/settings';
import { nanoid } from 'nanoid';
import Branding from './branding/branding';

export interface VersionedLogo {
  logoUrl: string;
  version: number;
}

function ThemeAndNotifications() {
  const { user, config } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>();

  const [orgLogoUrl, setOrgLogoUrl] = useState<VersionedLogo>({
    logoUrl: `https://parcel-tracer-public.s3.eu-central-1.amazonaws.com/${user?.organisation?.org_id}/logo.png?v=${new Date().getTime()}`,
    version: 0,
  });
  const [orgSettings, setOrgSettings] =
    useState<OrganisationSettings>(emptyOrgSettings);

  useEffect(() => {
    const fetchOrgSettings = async () => {
      try {
        const response = await axios.get<OrganisationSettings>(
          `${API_ENDPOINT}/api/v1/settings`,
          config
        );
        setOrgSettings(response.data);

        if (!response.data.has_logo)
          updateLogoUrl(
            `https://parcel-tracer-public.s3.eu-central-1.amazonaws.com/system/logo.png?v=${new Date().getTime()}`
          );
      } catch (e) {
        if (axios.isAxiosError(e)) {
          setError('Failed to load organisation settings: ' + e.message);
        } else {
          setError('Failed to load  organisation settings');
        }
        console.log(e);
      }

      setLoading(false);
    };

    fetchOrgSettings();
  }, []);

  console.log(orgLogoUrl);

  const updateLogoUrl = (newUrl: string) => {
    setOrgLogoUrl({
      logoUrl: newUrl,
      version: orgLogoUrl.version + 1,
    });
  };

  const getFreshLogoUrl = () => {
    return `${orgLogoUrl.logoUrl}?${nanoid(1)}`;
  };

  return (
      <Box>
        {loading ? (
          <LinearProgress />
        ) : (
          <>
            {error ? (
              <Alert severity="error">{error}</Alert>
            ) : (
              <>
                <Grid2 spacing={2} container alignItems="stretch">
                  <Grid2 xs={12} md={4} display="flex">
                    <Section title="Company Logo">
                      <LogoUploader
                        logoUrl={getFreshLogoUrl()}
                        updateLogoUrl={updateLogoUrl}
                      />
                      <Alert severity="info">
                        {' '}
                        Logo will be visible to customers in whatsapp
                        notifications and order tracking pages{' '}
                      </Alert>
                    </Section>
                  </Grid2>

                  <Grid2 xs={12} md={4} display="flex">
                    <Section title="Customize Theme">
                      <ThemeColor settings={orgSettings} />
                    </Section>
                  </Grid2>

                  <Grid2 xs={12} md={4} display="flex">
                     <Section title="Company Signature">
                  <Branding
                    settings={orgSettings}
                  />
                </Section>
                  </Grid2>
                </Grid2>

                    <Section title="Customer Notifications">
                      <NotificationManagerTemplates
                        logoUrl={getFreshLogoUrl()}
                        notification_templates={orgSettings.notification_templates}
                      />
                    </Section>
              </>
            )}
          </>
        )}
      </Box>
  );
}

export default ThemeAndNotifications;
